import { makeStyles, Button, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from "date-fns/locale/fr";
import Strapi from '../../services/strapi';
import { useNotification } from '../../contexts/Notification';
import Fetcher from '../../services/fetcher';
import settings from '../../settings';
import { Share, Notif } from '../../interfaces/article';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1
  },
  element: {
    display: 'block',
    marginLeft: 5,
    marginRight: 5,
    minWidth: 170,
    boxSizing: 'unset'
  },
}));

interface Props {
  articleId: number,
  articleType: string,
  defaultValue: string | null,
  article: any,
};

const ArticleDatePicker = (props: Props) => {
  const classes = useStyles();
  const [defaultDate] = useState<Date | null>(props.defaultValue === null ? null : new Date(props.defaultValue));
  const [date, setDate] = useState<Date | null>(props.defaultValue === null ? null : new Date(props.defaultValue));
  const notification = useNotification();

  const handleDateChange = (date: Date | null) => {
    if (date !== null) {
      date.setSeconds(0, 0);
    }
    setDate(date);
  };
  const [loading, setLoading] = useState<boolean>(false);

  const publish = (datetime: number | null) => {
    setLoading(true)
    Strapi.put(`${props.articleType}s/${props.articleId}/publish`, {}, {
      publish_date: datetime === null ? null : datetime
    }).then(r => {
      if (datetime === null) {
        notification.notify(`Article dépublié`);
      } else {
        console.log(props.article.share)
        if ([Share.Share, Share.ShareNow].includes(Share[props.article.share as keyof typeof Share])) {
          console.log(props.article);
          console.log({r})
          Fetcher.post(settings.sharingApi, JSON.stringify({
              article: props.article.slug,
              caption: props.article.title,
              type: props.articleType,
              priority: props.article.share === Share[Share.ShareNow],
              url: `${settings.frontUrl}article/${props.articleType}/${props.article.slug}`,
              publishedDate: (new Date(r.publish_date)).getTime(),
            }))
            .catch(e => {
              notification.notify("fail to send to share queue", "error")
            })
        }
        if ([Notif.Notif, Notif.NotifNow].includes(Notif[props.article.notif as keyof typeof Notif])) {
            Fetcher.post(settings.notifApi, JSON.stringify({
                article: props.article.slug,
                caption: props.article.short_hat ?? props.article.long_hat,
                type: props.articleType,
                now: props.article.notif === Notif[Notif.NotifNow],
                url: `${settings.frontUrl}article/${props.articleType}/${props.article.slug}`,
                publishedDate: (new Date(props.article.publish_date)).getTime(),
            }))
            .catch(e => {
              notification.notify("fail to send to share queue", "error")
            })
        }
        const rdate = new Date(datetime);
        const datestring = rdate.toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        notification.notify(`Publication programmée au ${datestring}`);
      }
    }).catch(e => {
      notification.notify(`fail to  ${datetime === null ? "un": ""}publish`, "error");
    }).finally(() => setLoading(false));
  };

  return (
    <div className={classes.container}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
        <KeyboardDateTimePicker
          className={classes.element}
          label={<div style={{fontSize: 12, paddingTop: 5}}>Date de publication</div>}
          value={date}
          onChange={handleDateChange}
          format="dd/MM/yyyy HH:mm"
          variant="inline"
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          ampm={false}
        />
      </MuiPickersUtilsProvider>
      {defaultDate?.getTime() === date?.getTime() ? (
        <>
          {defaultDate === null ? (
            <Button onClick={() => publish(Date.now())}>Publier maintenant</Button>
          ) : (
            <Button onClick={() => publish(null)}>Déprogrammer</Button>
          )}
        </>
      ) : (
        <>
          <Button onClick={() => setDate(defaultDate)}>Reset</Button>
          <Button onClick={() => publish(date?.getTime() as number)}>Programmer</Button>
        </>
      )}
      {loading && <CircularProgress />}
    </div>
  );
};

export default ArticleDatePicker